import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
// NOTE: the plain npm `bootstrap` package's CSS used to be imported here.
// It's the default (unthemed, blue) Bootstrap build, and webpack injects
// JS-imported CSS like this into <head> *after* the CET-HTML-Code theme's
// own compiled Bootstrap (vendors.min.css / app.min.css, loaded via
// <link> tags in public/index.html) -- so it was silently overriding
// parts of the theme's own styling. Removed now that every page is
// meant to use the theme's CSS instead.

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
